/* eslint-disable quote-props */

module.exports = {
  'Account security': 'Segurança da conta',
  'Phone was updated': 'Telefone foi atualizado',
  'Phone is empty': 'Telefone está vazio',
  'Link is no longer valid': 'Esse link não é mais válido!',
  'Invalid link': 'Esse link é inválido!',
  'Incorrect link': 'Esse link está incorreto!',
  'Email was updated': 'O e-mail foi atualizado!',
  'GO TO LOGIN PAGE': 'IR PARA PÁGINA DE LOGIN',
  'PURCHASE': 'COMPRAR',
  'SUBSCRIBE': 'ASSINAR',
  'Dark Mode': 'Modo Escuro',
  'Light Mode': 'Modo Claro',
  'Synonymous': 'Sinônimos',
  'Spintax': 'Spintax',
  'Summarize': 'Resumir',
  'Paraphrase': 'Parafrasear',
  'Videos': 'Vídeos',
  'Support': 'Suporte',
  'Payments': 'Pagamentos',
  'Account': 'Conta',
  'Admin': 'Admin',
  'Texts': 'Textos',
  'Synonymous Tool': 'Ferramenta Sinônimos',
  'Type or paste your text to generate another with synonymous (500 words maximum)': 'Digite ou cole seu texto para gerar outro com sinônimos (máximo 500 palavras)',
  'Protect words (press TAB key to insert)': 'Proteger palavras (aperte tecla TAB para inserir)',
  'Generate text': 'GERAR TEXTO',
  'Text copied to clipboard!': 'Texto copiado para a área de transferência!',
  'Copy text': 'Copiar texto',
  'Save': 'Salvar',
  'DOWNLOAD PDF': 'BAIXAR PDF',
  'DOWNLOAD TXT': 'BAIXAR TXT',
  'DOWNLOAD DOCX': 'BAIXAR DOCX',
  'DELETE': 'EXCLUIR',
  'Spintax Tool': 'Ferramenta Spintax',
  'Paraphrase Tool': 'Ferramenta Paráfrase',
  'Summarize Tool': 'Ferramenta Resumo',
  'Type or paste your text to generate spintax': 'Digite ou cole seu texto para gerar spintax',
  'Generate spintax': 'GERAR SPINTAX',
  'Generate summary': 'GERAR RESUMO',
  'Generate paraphrase': 'REESCREVER',
  'Spintaxed Text': 'Texto Spintaxado',
  'Enter synonym': 'Digite o sinônimo',
  'List of synonyms': 'Lista de sinônimos',
  'Synonyms used': 'Sinônimos usados',
  'Synonyms removed': 'Sinônimos removidos',
  'Your Reescrever subscription will be renewed at:': 'Sua assinatura do Reescrever será renovada em:',
  'The monthly fee is charged at the beginning of each billing period. Some days may pass before the charge appears in your account.': 'A mensalidade é cobrada no início de cada período de cobrança. Alguns dias podem transcorrer antes da cobrança ser exibida na sua conta.',
  'Your Reescrever subscription will be canceled on:': 'Sua assinatura do Reescrever será cancelado em:',
  'RESTART SUBSCRIPTION': 'REINICIAR ASSINATURA',
  'UNSUBSCRIBE': 'CANCELAR ASSINATURA',
  'Invoice': 'Fatura',
  'Period': 'Período',
  'Price': 'Preço',
  'Type': 'Tipo',
  'Description': 'Descrição',
  'NOTE: We only show up to one year of billing history': 'NOTA: Mostramos apenas até um ano do histórico de cobranças',
  'Set as default': 'Definir como principal',
  'Add new card': 'Adicionar novo cartão',
  'Cancel': 'Cancelar',
  'Choose card': 'Escolher cartão',
  'Delete card': 'Deletar cartão',
  'My cards': 'Meus cartões',
  'Before making the payment, we ask that you read and accept the terms of the agreement.': 'Antes de realizar o pagamento, solicitamos que você leia e aceite os termos do contrato.',
  'Select credit card': 'Selecionar cartão de crédito',
  'View bank details': 'Exibir dados bancários',
  'Pay with Paypal': 'Pagar com Paypal',
  'REESCREVER AGREEMENT': 'CONTRATO DO REESCREVER',
  'I accept the contract': 'Aceito o contrato',
  'Credit card': 'Cartão de crédito',
  'Deposit and transfer': 'Depósito e transferência',
  'Paypal': 'Paypal',
  'Weekly Plan': 'Plano Semanal',
  'Monthly Plan': 'Plano Mensal',
  'Quarterly Plan': 'Plano Trimestral',
  'Semiannual Plan': 'Plano Semestral',
  'Annual Plan': 'Plano Anual',
  'Unlimited Texts': 'Textos Ilimitados',
  'Artificial intelligence': 'Inteligência Artificial',
  'Spintax Format': 'Formato Spintax',
  'API': 'API',
  'Copyscape': 'Copyscape',
  'CONTRACT': 'CONTRATO',
  'After paying by PayPal, we ask that you wait up to 24 hours to activate your account.': 'Após realizar o pagamento pelo PayPal pedimos que aguarde até 24 horas para ativarmos sua conta.',
  'I confirm that I have read and accept Reescrever\'s contract': 'Confirmo que li e aceito o contrato do Reescrever',
  'Transfer the value of the selected plan to the account:': 'Transfira o valor do plano selecionado para a conta:',
  'Nu Pagamentos S.A.': 'Nu Pagamentos S.A.',
  'CNPJ: 21.719.922/0001-23': 'CNPJ: 21.719.922/0001-23',
  'GLEIDSON HENRIQUE FRIA 39326490874': 'GLEIDSON HENRIQUE FRIA 39326490874',
  'Agency: 0001': 'Agência: 0001',
  'Checking account: 52137597-4': 'Conta Corrente: 52137597-4',
  'After making the deposit / transfer, send us the receipt.': 'Após realizar o depósito / transferência, nos envie o comprovante.',
  'You must accept the contract!': 'Você deverá aceitar o contrato!',
  'The voucher was sent successfully!': 'O comprovante foi enviado com sucesso!',
  'We request a 24-hour period to register the payment in your account. Generally, registration occurs in less time. Any questions, we are available at the email suporte@reescrever.app': 'Pedimos o prazo de 24 horas para cadastrar o pagamento em sua conta. Geralmente, o cadastro ocorre em menos tempo. Qualquer dúvida, estamos a disposição no e-mail suporte@reescrever.app',
  'Drag and drop voucher here or click to send': 'Arraste e solte o comprovante aqui ou clique para enviar',
  'This file is too large. Please compact it before send.': 'Este arquivo é muito grande. Compacte-o antes de enviar.',
  'Enter your credential': 'Para entrar, digite os dados de acesso:',
  'Email': 'E-mail',
  'Password': 'Senha',
  'Forgot your password?': 'Esqueceu sua senha?',
  'Log in': 'ENTRAR',
  'Email is required': 'O e-mail é obrigatório',
  'Email invalid': 'Esse e-mail não é válido',
  'Password is required': 'A senha é obrigatória',
  '6 characters minimum': 'Mínimo 6 caracteres',
  '6 characters maximum': 'Mínimo 6 caracteres',
  'Register by filling in the data below': 'Registre-se preenchendo os dados abaixo',
  'Full name': 'Nome completo',
  'REGISTER': 'REGISTRAR',
  'Name is required': 'O nome é obrigatório',
  '2 characters minimum': 'Mínimo 2 caracteres',
  'Create a new password': 'Gerar uma nova senha',
  'Your new password has been generated and sent to your email. Enter your email to regain access to your Reescrever account.': 'Sua nova senha foi gerada e enviado para seu e-mail. Entre em seu e-mail para recuperar acesso à sua conta do Reescrever.',
  'RECOVER ACCOUNT': 'RECUPERAR CONTA',
  'More videos': 'Mais vídeos',
  'Ooops... looks like an error occurred!': 'Ops, parece que ocorreu algum erro!',
  'Ooops... looks like an error occurred! Try again in a few minutes. If does not work, send this text to our support to analyze the reason for the error.': 'Ops, parece que ocorreu algum erro! Tente novamente em alguns minutos. Se não funcionar, envie esse texto para o nosso suporte analisar o motivo do erro.',
  'Error code': 'Código do Erro',
  'GO BACK HOME': 'IR PARA PÁGINA INICIAL',
  'User data': 'Dados do usuário',
  'Charging and subscription': 'Assinatura e cobrança',
  'Change card': 'Alterar cartão',
  'Change payment method': 'Alterar forma de pagamento',
  'Charge details': 'Detalhes da cobrança',
  'Unsubscribe': 'Cancelar assinatura',
  'Change phone': 'Alterar telefone',
  'Change email': 'Alterar e-mail',
  'Change password': 'Alterar senha',
  'Name': 'Nome',
  'Please enter your name': 'Por favor, digite seu nome',
  'Occupation': 'Profissão',
  'Please enter your email': 'Por favor, digite seu e-mail',
  'Invalid email': 'Esse e-mail não é válido',
  'Cell phone': 'Celular',
  'Search': 'Pesquisar',
  'EXCLUIR': '* Precisa confirmar com código enviado',
  'Current password': 'Senha atual',
  'Enter your current password': 'Digite sua senha atual',
  'New password': 'Nova senha',
  'Enter a new password': 'Digite a nova senha',
  'Confirm password': 'Confirmar senha',
  'Enter your new password': 'Digite a nova senha',
  'Password doesn\'t match': 'A senha está diferente',
  'Your API KEY': 'Sua Chave API',
  'Change key': 'Alterar chave',
  'The Reescrever API allows you to integrate Reescrever with your SEO tools for the purpose of automating processes.': 'A API do Reescrever permite a você integrar o Reescrever as suas ferramentas de SEO, com a finalidade de automatizar processos.',
  'Learn more about API integration': 'Saiba mais sobre integração pela API',
  'UPDATE': 'ATUALIZAR',
  'ADD CARD': 'ADICIONAR CARTÃO',
  'Number card': 'Número do cartão',
  'Name (exactly as on card)': 'Nome (como no cartão)',
  'Expiring date (MM/AA)': 'Validade (MM/AA)',
  'MM/AA': 'MM/AA',
  'CVC': 'CVC',
  'Valid thru': 'Validade',
  'Use card as default': 'Usar cartão como principal',
  'Your current Reescrever plan is: Monthly Plan. Subscription expiration and renewal is:': 'Sua plano atual do Reescrever é: Plano Mensal. O vencimento e renovação da assinatura é:',
  'The monthly fee is charged at the expiration of the subscription. When changing the plan, billing and change to the new plan will only occur after the end of the contracted period. Therefore, the new plan will only come into force on': 'A mensalidade é cobrada no vencimento da assinatura. Ao alterar o plano, a cobrança e mudança para o novo plano só ocorrerá após o término do período já contratado. Portanto, o novo plano só entrará em vigor em',
  'CHANGE PLAN': 'TROCAR PLANO',
  'Enter to filter questions': 'Digite para filtrar as perguntas',
  'Write your doubt below': 'Escreva sua dúvida abaixo',
  'Write here your question to the Reescrever team...': 'Escreva sua dúvida para a equipe Reescrever aqui...',
  'Category': 'Categoria',
  'Send question': 'Enviar pergunta',
  'Ok! Thanks.': 'Ok! Obrigado.',
  'Send a question': 'Enviar uma pergunta',
  'API Key was updated': 'Chave API foi atualizada',
  'Name is empty': 'Nome está vazio',
  'User data was updated': 'Usuário foi atualizado',
  'New email is empty': 'Novo e-mail está vazio',
  'Verification email has been sent': 'Foi enviado e-mail de validação',
  'You must confirm on both emails to make the change': 'Você deve confirmar em ambos emails para realizar a mudança.',
  'You must confirm your email': 'Você deve confirmar seu e-mail',
  'Current password is empty': 'Senha atual está vazia',
  'New password is empty': 'Nova senha está vazia',
  'Current password must be at least 6 characters': 'Senha atual com pelo menos 6 caracteres',
  'New password must be at least 6 characters': 'Nova senha com pelo menos 6 caracteres',
  'User password was updated': 'A senha do usuário foi atualizada',
  'User not found': 'Usuário não encontrado',
  'Password not match': 'Senha não corresponde',
  'Email has been confirmed': 'Seu e-mail foi confirmado',
  'Email has been updated': 'O e-mail foi atualizado',
  'E-mail has already been confirmed': 'E-mail já foi confirmado',
  'Current email change confirmed. You now need to confirm the new email.': 'O e-mail atual foi confirmado. Agora você precisa confirmar o novo e-mail.',
  'New email change confirmed. You now need to confirm the current email.': 'O novo e-mail foi confirmado. Agora você precisa confirmar o e-mail atual.',
  'This is the current email. To change you need to choose another email.': 'Este é o e-mail atual. Para alterar você precisa escolher outro e-mail.',
  'An SMS code will be sent': 'Um código SMS será enviado',
  'SMS Code': 'Código SMS',
  'Use {{phoneCode}} to verify your phone on Reescrever': 'Utilize {{phoneCode}} para confirmar seu telefone no Reescrever',
  'Phone is invalid': 'Número é inválido',
  'Phone number is not mobile': 'O número não é de celular',
  'Please enter SMS Code': 'Por favor, digite o código SMS',
  'SMS Code is incorrect': 'O Código SMS está incorreto',
  'Phone has been confirmed and updated': 'O telefone foi confirmado e atualizado',
  'SMS code has been sent': 'O Código SMS foi enviado',
  '* Confirm your phone with SMS code sent.': '* Confirme seu celular com o código SMS enviado.',
  'SMS code has been resent': 'O Código SMS foi reenviado',
  'Not a phone number': 'Não é um número de telefone',
  'Phone must be different from the current one': 'Telefone deve ser diferente do atual',
  'Click to copy the API': 'Clique para copiar a API',
  'API Key was copied to the clipboard': 'Chave API foi copiada para a área de transferência',
  'Please enter credit card number': 'Digite o número do cartão',
  'Please enter credit card name': 'Digite seu nome (como no cartão)',
  'Please enter credit card expiration': 'Digite a data de expiração do cartão',
  'Please enter credit card CVV': 'Digite o CVV do cartão',
  '12 number minimum': 'Mínimo 12 números',
  '13 number minimum': 'Mínimo 13 números',
  '14 number minimum': 'Mínimo 14 números',
  '15 number minimum': 'Mínimo 15 números',
  '16 number minimum': 'Mínimo 16 números',
  '17 number minimum': 'Mínimo 17 números',
  '18 number minimum': 'Mínimo 18 números',
  '19 number minimum': 'Mínimo 19 números',
  '20 number minimum': 'Mínimo 20 números',
  '3 number minimum': 'Mínimo 3 números',
  '4 number minimum': 'Mínimo 4 números',
  'Phone is already used by another user': 'Telefone já é usado por outro usuário',
  'Contract must be accept': 'Contrato deve ser aceito',
  'Preferred': 'Preferido',
  'Define as preferred': 'Definir como preferido',
  'ADD PAYPAL': 'ADICIONAR PAYPAL',
  'Recurring payment': 'Pagamento recorrente',
  'Actions': 'Ações',
  'Delete': 'Deletar',
  'Show card data': 'Mostrar dados do cartão',
  'cardID is empty': 'cardID é vazio',
  'Error changing default payment': 'Erro ao trocar o pagamento padrão',
  'Error removing payment': 'Erro ao remover o pagamento',
  'Expiry date is invalid': 'Digite a data de expiração do cartão',
  'Expiry month should be between 01 and 12': 'Mês deve estar entre 01 e 12',
  'Expiry year cannot be in the past': 'Ano deve ser igual ou maior que atual',
  'Card expired': 'Cartão está vencido',
  'Card is invalid': 'Cartão é inválido',
  'Already have an account?': 'Já possui uma conta?',
  'Don\'t have an account yet?': 'Ainda não possui uma conta?',
  'Sign in': 'Entrar',
  'Sign up': 'Registrar',
  'Add a credit card or paypal': 'Adicione um cartão de crédito ou paypal',
  'You don\'t have an added form of payment yet. First add a credit card or link your paypal account for a recurring subscription.': 'Você ainda não possui uma forma de pagamento adicionada. Primeiramente adicione um cartão de crédito ou vincule sua conta paypal para assinatura recorrente.',
  'Transfer receipts': 'Comprovantes de transferência',
  'Delete transfer receipt': 'Excluir comprovante de transferência',
  'The voucher must be deleted only if you are sure that the payment has not occurred and that it will not actually happen.': 'A exclusão do comprovante deve ser realizado somente se tiver certeza que o pagamento não ocorreu e que realmente não irá acontecer.',
  'Generally, transfers can take up to 3 days to appear. If it has already passed and has not yet appeared, it may be that some of the data is wrong or that the user made an appointment instead of transferring.': 'Geralmente, transferências podem demorar até 3 dias para aparecer. Se já passou e ainda não apareceu, pode ser que algum dos dados estão errados ou que o usuário fez um agendamento invés de transferência.',
  'When deleting the receipt, an email will be sent to the user.': 'Ao excluir o comprovante, um e-mail será enviado ao usuário.',
  'Are you sure you want to proceed?': 'Tem certeza que deseja prosseguir?',
  'Yes': 'Sim',
  'No': 'Não',
  'Find users and logs': 'Encontre usuários e logs',
  'Delete payment method': 'Excluir forma de pagamento',
  'When you delete the payment method, it will no longer be used. You can add it again if you wish.': 'Ao excluir a forma de pagamento, ela não será mais utilizada. Você poderá adiciona-la novamente, caso desejar.',
  'Since this is the preferred payment method, when it is deleted, another random payment method will be set as preferred. If desired, you can define another preferred payment method before or after deletion.': 'Como essa é a forma de pagamento preferida, ao ser excluída, outra forma de pagamento aleatória será definida como preferida. Caso desejar, você pode definir outra forma de pagamento preferida antes ou após a exclusão.',
  'As it is the only payment method, the subscription will be canceled and will not be renewed later, thus causing the Reescrever to be interrupted before you finish your job. Your subscription will only be active until the end of the paid period.': 'Como ela é a única forma de pagamento, a assinatura será cancelada e não será renovada posteriormente, podendo assim causar a interrupção do Reescrever antes de você finalizar seus trabalhos. Sua assinatura ficará ativa somente até o término do mês pago.',
  'Regular price': 'Preço normal',
  '10% off': '10% de desconto',
  '20% off': '20% de desconto',
  '30% off': '30% de desconto',
  'Account balance': 'Saldo em conta',
  'Add balance': 'Adicionar saldo',
  'Bank transfer': 'Transferência bancária',
  'You can add balance to your account through Bank Billet and Bank Transfer and use it to sign up for Reescrever, without needing a credit card.': 'Você pode adicionar saldo em sua conta através de Boleto e Transferência Bancária e utilizar para assinar o Reescrever, sem precisar de um cartão de crédito.',
  'How do you prefer to add balance?': 'Como prefere adicionar o saldo?',
  'Bank billet': 'Boleto',
  'Transfer': 'Transferência',
  'Delete text': 'Excluir texto',
  'After deleting the text, it will no longer be possible to obtain it again.': 'Após excluir o texto, não será mais possível obte-lo novamente.',
  'Make sure you have a copy in a safe place before deleting.': 'Certifique que possui uma cópia em local seguro antes de excluir.',
  'Spinned text was updated': 'Texto spinneado foi atualizado',
  'Text was updated': 'Texto foi atualizado',
  'The spinning process is taking place. At the moment, this process is taking too long, in some cases even more than 5 minutes. So be patient. If an error occurs, you will be informed.': 'O processo de spinnear está ocorrendo. No momento, esse processo está demorando muito, em alguns casos até mais do que 5 minutos. Portanto, seja paciente. Caso ocorrer algum erro, você será informado.',
  'Your paraphrased text is being generated': 'Seu texto parafraseado está sendo gerado',
  'Rephrase': 'Reformular frase',
  'OriginalSentence': 'Frase Original',
  'NEW': 'NOVO',
  'NEW TEXT': 'NOVO TEXTO',
  'Are you sure?': 'Tem certeza?',
  'Make sure you have saved text before proceeding. It will not be possible to recover it.': 'Tenha certeza de ter salvo o texto antes de prosseguir. Não será possível recupera-lo.',
  'E-mail already registered': 'Email já cadastrado',
  'User no longer exists': 'Usuário não existe mais',
  'E-mail has been updated previously. Nothing has been accomplished now.': 'E-mail já foi atualizado anteriormente. Nada foi realizado agora.',
  'It is currently possible to paraphrase only in Portuguese': 'Atualmente é possível parafrasear apenas em Português',
  'Validate your email to be able to use Reescrever. A welcome email with a validation button was sent to': 'Valide seu e-mail para conseguir usar o Reescrever. Foi enviado um e-mail de boas vindas com botão de validação para',
  'Select a phrase before generating a new paraphrase': 'Selecione uma frase antes de gerar uma nova paráfrase',
  'Copy': 'Copiar',
  'Text was copied to the clipboard': 'Texto foi copiado para área de transferência',
  'The limit is 300 words for the free plan': 'O limite é de 300 palavras para o plano gratuito.',
  'The limit is 1000 words for the free plan': 'O limite é de 1000 palavras para o plano gratuito.',
  'The limit is 2000 words for paid plans': 'O limite é de 2000 palavras para os planos pagos',
  'The limit is 5000 words for paid plans': 'O limite é de 5000 palavras para os planos pagos',
  'An error occurred while copying the text': 'Ocorreu um erro ao copiar o texto',
};
